module.exports = __webpack_public_path__ + "img/md-item06.ef28143.png";